import flatpickr from "flatpickr";

document.addEventListener("DOMContentLoaded", () => {
  flatpickr(document.querySelectorAll(".webform-popup .form-date"), {
    dateFormat: "m/d/Y",
  });

  const eventTourPage = document.querySelector(".page-node-type-event-tour");

  if (eventTourPage) {
    const eventContent = eventTourPage.querySelector(
      ".event-main-box > .event-content"
    );
    const eventTourLead = eventTourPage.querySelector(".event-tour-lead");
    //const eventMainBox = eventTourPage.querySelector(".event-main-box");

    eventContent.prepend(eventTourLead.cloneNode(true));
  }

  const checkoutSidebarLeft = document.querySelector(
    ".path-checkout .section.sidebar-left"
  );

  if (checkoutSidebarLeft) {
    const layoutContainer = document.querySelector(
      "#page-content #before-content .layout-container"
    );

    const checkoutProgressTitle = document.createElement("div");
    checkoutProgressTitle.innerHTML =
      "<div class='block-title'><h3>Checkout progress</h3></div>";

    if (layoutContainer) {
      layoutContainer.insertBefore(
        checkoutProgressTitle,
        layoutContainer.firstChild
      );
    }
  }

  if (document.querySelector(".event-tour-sidebar .field-reserve-button a")) {
    document
      .querySelector(".event-tour-sidebar .field-reserve-button a")
      .classList.add("reserve-now-button");
  }

  if (document.querySelector(".event-tour-sidebar .register-button a")) {
    document
      .querySelector(".event-tour-sidebar .register-button a")
      .classList.add("button-transparent");
  }

  document.querySelectorAll(".bike-ajax-load").forEach(function (element) {
    element.addEventListener("click", function (e) {
      const nid = document.querySelector(".form-item-nid");

      if (nid) {
        const nidInput = nid.querySelector("input");
        nidInput.value = element.getAttribute("category");

        nidInput.dispatchEvent(new Event("change"));
        window.history.pushState(
          "object or string",
          "Title",
          element.getAttribute("href")
        );

        document.querySelector("#block-blazingsaddles-local-tasks").remove();
      }
    });
  });

  if (document.querySelector(".promotion-block-block-boxes")) {
    document
      .querySelectorAll(
        ".promotion-block-block-boxes .field-boxes > .field-item"
      )
      .forEach((item) => {
        if (item.querySelector(".block-box-buttons .field-item")) {
          const buttonLink = item
            .querySelector(".block-box-buttons .field-item a")
            .getAttribute("href");
          const buttonContents = item.querySelector(".node").innerHTML;

          item.querySelector(".node").innerHTML =
            "<a href=" + buttonLink + ">" + buttonContents + "</a>";
        }
      });

    document
      .querySelectorAll(
        ".promotion-block-block-boxes .field-subpage > .field-item"
      )
      .forEach(function (item) {
        if (item.querySelector(".block-box-buttons .field-item")) {
          item.querySelector("article").innerHTML =
            "<a href=" +
            item
              .querySelector(".block-box-buttons .field-item a")
              .getAttribute("href") +
            ">" +
            item.querySelector("article").innerHTML +
            "</a>";
        }
      });
  }

  document.querySelectorAll("a").forEach(function (link) {
    const href = link.getAttribute("href");
    if (typeof href !== "undefined" && href?.indexOf("#") >= 0) {
      link.setAttribute("goto", href.substring(href.indexOf("#")));
      link.classList.add("scrollto");
    }
  });

  document.querySelectorAll(".back-to-top .scrollto").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });
});
